import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const makeAiSearch = (payload) =>
  httpClient.post(apis.makeAiSearch(), payload, { ignore: true });

export const doAiSearch = (payload) =>
  httpClient.post(apis.DO_AI_SEARCH, { ...payload }, { ignore: true });

export const getAiHistory = () => httpClient.get(`${apis.GET_AI_HISTORY}`);

